export default __webpack_public_path__ + "locales/ar-SA/InviteDialog.json?hash=cb2de0e62edb5a25f2f06bdc99517b67";